import styled from 'styled-components';

export const PaginationContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
	width: 100%;
	margin-top: 16px;
	justify-content: flex-end;
`;

export const PaginationText = styled.p`
	flex: 1;
	font-family: 'Segoe UI', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #262626;
	letter-spacing: -0.07px;
	margin: 0;
`;

export const PaginationButtons = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	justify-content: flex-end;
`;

export const PaginationArrow = styled.button<{ $disabled?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	background: transparent;
	border: none;
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
	opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;

export const PaginationNumber = styled.button<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 8px 12px;
	border-radius: 4px;
	border: none;
	cursor: pointer;
	font-family: 'Segoe UI', sans-serif;
	font-weight: 600;
	font-size: 14px;
	line-height: 16px;

	background-color: ${({ $active }) => ($active ? '#e6eaf8' : '#f0f0f0')};
	color: ${({ $active }) => ($active ? '#002fbb' : '#bfbfbf')};

	&:hover {
		background-color: ${({ $active }) => ($active ? '#e6eaf8' : '#e6e6e6')};
	}
`;

export const EmptyState = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 32px;
	background-color: #f8f8f8;
	border-radius: 8px;
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	color: #bfbfbf;
`;
